// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__V7LMG","author":"Table_author__2py6e","authorImage":"Table_authorImage__1jzjA","unreadRow":"Table_unreadRow__2cMQl"};